module.exports = __webpack_public_path__ + "images/2fc0b38.png";